import api from './api';

export const getOrders = (currentPage, PageSize, search, config) => {
    let errors = [];
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Order/GetOrders?PageNumber=${currentPage}&PageSize=${PageSize}&search=${encodeURIComponent(search)}`, config);
    }
}

export const getUserOrders = (user, currentPage, PageSize, config) => {
    let errors = [];
    if (!user) {
        errors.push('current page');
    }
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Order/GetUserOrders/${user.id}?PageNumber=${currentPage}&PageSize=${PageSize}`, config);
    }
}
